// export default ProductMap = {
exports.ProductMap = {
  5: {
    '2 kWh': [{
      name: 'Get Set Kit (2kWh)',
      pid: '7346809602212',
      varId: '42347814584484',
      adaptBatCap: 2,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '3898',
      old_price: '4898',
      save_money: '1000',
      imgSrc: '/img/mm100/preview/setkit-2kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 2kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-2kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (2kWh)',
      pid: '7346809602212',
      varId: '42347814617252',
      adaptBatCap: '2-1',
      limit: 2,
      consoleChoose: 'Y',
      off_price: '4398',
      old_price: '5468',
      save_money: '1070',
      imgSrc: '/img/mm100/preview/prekit-2kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Battery Mounting Strap'],
      detailImgList: ['bundle-2kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (2kWh)',
      pid: '7346809602212',
      varId: '42347814650020',
      adaptBatCap: '2-1',
      limit: 2,
      off_price: '4698',
      old_price: '5798',
      save_money: '1100',
      imgSrc: '/img/mm100/preview/indkit-2kw-us.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '1x Battery Mounting Strap'],
      detailImgList: ['bundle-2kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '4 kWh': [{
      name: 'Get Set Kit (4kWh)',
      pid: '7346809667748',
      varId: '42347815141540',
      adaptBatCap: 2,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '5597',
      old_price: '7097',
      save_money: '1500',
      imgSrc: '/img/mm100/preview/setkit-4kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 2kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-4kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (4kWh)',
      pid: '7346809667748',
      varId: '42347815174308',
      adaptBatCap: '2-1',
      limit: 1,
      consoleChoose: 'Y',
      off_price: '6097',
      old_price: '7667',
      save_money: '1570',
      imgSrc: '/img/mm100/preview/prekit-4kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '2x Battery Mounting Strap'],
      detailImgList: ['bundle-4kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (4kWh)',
      pid: '7346809667748',
      varId: '42347815207076',
      adaptBatCap: '2-1',
      limit: 1,
      off_price: '6397',
      old_price: '7997',
      save_money: '1600',
      imgSrc: '/img/mm100/preview/indkit-4kw-us.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '2x Battery Mounting Strap'],
      detailImgList: ['bundle-4kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '5 kWh': [{
      name: 'Get Set Kit (5kWh)',
      pid: '7346809700516',
      varId: '42347815272612',
      adaptBatCap: 5,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '5998',
      old_price: '7498',
      save_money: '1500',
      imgSrc: '/img/mm100/preview/setkit-5kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 5kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-5kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (5kWh)',
      pid: '7346809700516',
      varId: '42347815305380',
      adaptBatCap: '5-1',
      limit: 2,
      consoleChoose: 'Y',
      off_price: '6498',
      old_price: '8068',
      save_money: '1570',
      imgSrc: '/img/mm100/preview/prekit-5kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Battery Mounting Strap'],
      detailImgList: ['bundle-5kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (5kWh)',
      pid: '7346809700516',
      varId: '42347815338148',
      adaptBatCap: '5-1',
      limit: 2,
      off_price: '6798',
      old_price: '8398',
      save_money: '1600',
      imgSrc: '/img/mm100/preview/indkit-5kw-us.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '1x Battery Mounting Strap'],
      detailImgList: ['bundle-5kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '10 kWh': [{
      name: 'Get Set Kit (10kWh)',
      pid: '7346809733284',
      varId: '42347815370916',
      adaptBatCap: 5,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '9797',
      old_price: '12297',
      save_money: '2500',
      imgSrc: '/img/mm100/preview/setkit-10kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 5kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-10kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (10kWh)',
      pid: '7346809733284',
      varId: '42347815403684',
      adaptBatCap: '5-1',
      limit: 1,
      consoleChoose: 'Y',
      off_price: '10297',
      old_price: '12867',
      save_money: '2570',
      imgSrc: '/img/mm100/preview/prekit-10kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '2x Battery Mounting Strap'],
      detailImgList: ['bundle-10kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (10kWh)',
      pid: '7346809733284',
      varId: '42347815436452',
      adaptBatCap: '5-1',
      limit: 1,
      off_price: '10597',
      old_price: '13197',
      save_money: '2600',
      imgSrc: '/img/mm100/preview/indkit-10kw-us.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '2x Battery Mounting Strap'],
      detailImgList: ['bundle-10kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '15 kWh': [{
      name: 'Get Set Kit (15kWh)',
      pid: '7346809766052',
      varId: '42347815469220',
      consoleChoose: 'Y',
      off_price: '13596',
      old_price: '17096',
      save_money: '3500',
      imgSrc: '/img/mm100/preview/setkit-15kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '3x 5kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-15kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (15kWh)',
      pid: '7346809766052',
      varId: '42347815501988',
      consoleChoose: 'Y',
      off_price: '14096',
      old_price: '17666',
      save_money: '3570',
      imgSrc: '/img/mm100/preview/prekit-15kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '3x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '3x Battery Mounting Strap'],
      detailImgList: ['bundle-15kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (15kWh)',
      pid: '7346809766052',
      varId: '42347815534756',
      off_price: '14396',
      old_price: '17996',
      save_money: '3600',
      imgSrc: '/img/mm100/preview/indkit-15kw-us.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '3x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '3x Battery Mounting Strap'],
      detailImgList: ['bundle-15kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }]
  }
};
exports.solarPanelMap = {
  5: [{
    name: '2*100W Rigid Solar Panel+2*Rigid solar mounting feet',
    pid: '7346811928740',
    varId: '42347831656612',
    old_price: '229',
    off_price: '179',
    save_money: '50',
    limit: 99,
    // discount: "%1=369%%2=729%%3=1089%%n={per=1,off=0}%",
    imgSrc: '/img/mm100/preview/rigid-100w.jpg'
  }, {
    name: '2*400W Rigid Solar Panel+4*Rigid solar mounting feet',
    pid: '7346811961508',
    varId: '42347831689380',
    old_price: '799',
    off_price: '599',
    // tips: "*This item excludes free shipping.",
    save_money: '200',
    limit: 99,
    imgSrc: '/img/mm100/preview/rigid-400w.jpg'
  }, {
    name: '1*100W Flexible Solar Panel',
    pid: '7346811994276',
    varId: '42347831722148',
    old_price: '149',
    off_price: '129',
    save_money: '20',
    limit: 99,
    imgSrc: '/img/mm100/preview/flexibel-100w.jpg'
  }]
};
exports.BatteryMap = {
  5: [{
    name: '2kWh LFP Battery + Mounting Strap + Battery Cable',
    pid: '7346811797668',
    varId: '42390597042340',
    off_price: '1748',
    old_price: '2248',
    save_money: '500',
    capacity: '2-1',
    imgSrc: '/img/mm100/preview/battery-2kw.jpg'
  }, {
    name: '5kWh LFP Battery + Mounting Strap + Battery Cable',
    pid: '7346811797668',
    varId: '42390600024228',
    off_price: '3848',
    old_price: '4848',
    save_money: '1000',
    capacity: '5-1',
    imgSrc: '/img/mm100/preview/battery-5kw.jpg'
  }
  // {
  //     name: '2kWh LFP Battery',
  //     pid: '7346811797668',
  //     varId: '42390597042340',
  //     off_price: '1699',
  //     old_price: '2199',
  //     save_money: '500',
  //     capacity: 2,
  //     imgSrc: '/img/mm100/preview/battery-2kw.jpg',
  // },
  // {
  //     name: '5kWh LFP Battery',
  //     pid: '7346811797668',
  //     varId: '42347827560612',
  //     off_price: '3799',
  //     old_price: '4799',
  //     save_money: '1000',
  //     capacity: 5,
  //     imgSrc: '/img/mm100/preview/battery-5kw.jpg',
  // },
  // {
  //     name: '2kWh LFP Battery + Mounting Strap',
  //     pid: '7346811797668',
  //     varId: '42390597042340',
  //     off_price: '1748',
  //     old_price: '2248',
  //     save_money: '500',
  //     capacity: '2-1',
  //     imgSrc: '/img/mm100/preview/battery-2kw.jpg',
  // },
  // {
  //     name: '5kWh LFP Battery + Mounting Strap',
  //     pid: '7346811797668',
  //     varId: '42390600024228',
  //     off_price: '3848',
  //     old_price: '4848',
  //     save_money: '1000',
  //     capacity: '5-1',
  //     imgSrc: '/img/mm100/preview/battery-5kw.jpg',
  // },
  ]
};

// exports.InstallationMap = {
//     5: {
//         pid: '7346812027044',
//         varId: '42347831754916',
//         off_price: '0',
//         old_price: '0',
//         save_money: '0',
//     },
// };

exports.ConsoleMap = {
  5: [{
    name: 'EcoFlow Power Kits Console',
    pid: '7372380209316',
    varId: '42445337428132',
    off_price: '349',
    old_price: '349',
    limit: 1,
    // save_money: '599',
    prdType: 'console',
    imgSrc: '/img/calculators/mm100/combo-console.jpg'
  }]
};
exports.ShopifyUrl = 'https://eu.ecoflow.com/';